module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-1.4633f73d.JPG";